/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M4,6.609 L4,8 L1.461,8.726 C0.933,8.877 0.5,9.45 0.5,10 L0.5,10.5 L6,10.5" />
      <path d="M7,6.578 L7,8 L9.538,8.726 C10.067,8.877 10.5,9.45 10.5,10 L10.5,10.5 L5,10.5" />
      <ellipse cx="5.5" cy="3.771" rx="3" ry="3.271" />
      <path d="M8.469,3.198 C7.969,3.698 6.539,3.674 6,2.67 C5,3.67 3.375,3.67 2.566,3.1" />
      <path d="M17,6.609 L17,8 L14.461,8.726 C13.933,8.877 13.5,9.45 13.5,10 L13.5,10.5 L19,10.5" />
      <path d="M20,6.594 L20,8 L22.538,8.726 C23.067,8.877 23.5,9.45 23.5,10 L23.5,10.5 L18,10.5" />
      <ellipse cx="18.5" cy="3.771" rx="3" ry="3.271" />
      <path d="M21.453,3.195 C20.953,3.695 19.539,3.674 19,2.67 C18,3.67 16.375,3.67 15.566,3.1" />
      <path d="M10.5,19.609 L10.5,21 L7.961,21.726 C7.433,21.877 7,22.45 7,23 L7,23.5 L12.5,23.5" />
      <path d="M13.5,19.609 L13.5,21 L16.038,21.726 C16.567,21.877 17,22.45 17,23 L17,23.5 L11.5,23.5" />
      <ellipse cx="12" cy="16.771" rx="3" ry="3.271" />
      <path d="M14.953,16.17 C14.453,16.67 13.039,16.674 12.5,15.67 C11.5,16.67 9.875,16.67 9.066,16.1" />
      <path d="M4,12.5 L6.5,15" />
      <path d="M20,12.5 L17.5,15" />
    </g>
  </svg>
);

export default Icon;
